import { lazy } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { Theme } from "../data/style/Theme";
import { useParams } from "react-router-dom";
import WodDisplay from "../components/WodDisplay";
import useScreenSize from "../context/ScreenContext";
import { CardTitle } from "../components/theme/texts";
import { scrollBar, SpacedRow } from "../data/style/Style";
import WorkoutStatistics from "../components/WorkoutStatistics";
import PerformancePie from "../components/charts/PerformancePie";
import ScoreRangeChart from "../components/charts/ScoreRangeChart";

const WorkoutScores = lazy(() => import("../components/WorkoutScores"));
const ScoresChart = lazy(() => import("../components/charts/ScoresChart"));

const ShowWorkout = () => {
  const { wodId } = useParams();
  const { size, mobileDevice } = useScreenSize();
  var [width] = size;

  return (
    <SpacedRow
      height={"85vh"}
      overflow={"auto"}
      sx={scrollBar}
      gap={2}
      pr={1}
      flexWrap={"wrap"}
    >
      <Stack
        justifyContent={"space-between"}
        width={width < 750 ? "100%" : "30%"}
        pb={1}
        gap={2}
      >
        <Box minHeight={!mobileDevice && "370px"}>
          <WodDisplay wodId={wodId} />
        </Box>
        <ScoresChart wodId={wodId} />
      </Stack>
      <Stack gap={2} width={width < 750 ? "100%" : "30%"}>
        <WorkoutScores wodId={wodId} />
        <WorkoutStatistics
          workoutId={wodId}
          width={width}
          mobileDevice={mobileDevice}
        />
      </Stack>
      <Stack gap={2} width={width < 750 ? "100%" : "35%"}>
        <Stack>
          <CardTitle subTitle={"Community"} mainTitle={"Athlete Results"} />
          <Box
            p={1}
            sx={{
              borderRadius: 4,
              border: 1,
              borderColor: Theme.palette.border,
              background: Theme.palette.card,
            }}
            height={"32vh"}
            minHeight={"200px"}
          >
            <PerformancePie wodId={wodId} />
          </Box>
        </Stack>
        <ScoreRangeChart wodId={wodId} />
      </Stack>
    </SpacedRow>
  );
};
export default ShowWorkout;
